// Active Berlingske game.
// Keep this value aligned with CurrentGameID in src/db/berlingske_config.go.
export const mainGameId = 197864;

// Static weekly winner reports for Codan Puljespillet.
// Keep the group id aligned with StaticWeeklyWinnerCodanGroupGameID in the backend config.
export const STATIC_WEEKLY_WINNER_CODAN_GROUP_ID = 2991;
export const STATIC_WEEKLY_WINNER_GROUP_IDS = [STATIC_WEEKLY_WINNER_CODAN_GROUP_ID];
export const STATIC_WEEKLY_WINNER_PREVIEW_LIMIT = 5;
export const STATIC_WEEKLY_WINNER_FULL_LIMIT = 10;

export function supportsStaticWeeklyWinners(groupId) {
    return STATIC_WEEKLY_WINNER_GROUP_IDS.indexOf(parseInt(groupId, 10)) !== -1;
}

// Users with access to the generated weekly CSV report pages.
export const USER_REPORTS_VIEWER_USER_ID = 637;
export const GROUP_REPORTS_VIEWER_USER_ID = 9886;

export function canViewUserReports(me) {
    return !!me && (me.IsGod || me.Id === USER_REPORTS_VIEWER_USER_ID);
}

export function canViewGroupReports(me) {
    return !!me && (me.IsGod || me.Id === GROUP_REPORTS_VIEWER_USER_ID);
}

export function canViewReportNavigation(me) {
    return canViewUserReports(me) || canViewGroupReports(me);
}

// Login redirects for each Berlingske brand.
export const redirectLoginUrl = () => {
    if (IS_BERLINGSKE) {
        return "https://www.berlingske.dk/aktiespil"
    } else if (IS_BT) {
        return "https://www.bt.dk/aktiespil"
    } else if (IS_EUROINVESTOR) {
        return "https://www.euroinvestor.dk/aktiespil"
    } else {
        return "https://qa19.bt-testing.dk/aktiespil"
    }
}



// WEBPACK FOOTER //
// ./src/GameConfig.js